import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import useMode from "../../../Hooks/useMode";
import profile from "../../../images/fahim.png";
import vd from "../../../images/intro.mp4";
import "./Banner.css";

import { Typewriter } from "react-simple-typewriter";

const Banner = () => {
  const { theme } = useMode();
  const [show, setShow] = useState(false);

  const handleVideoOpen = () => {
    setShow(true);
  };
  const handleVideoClose = () => {
    setShow(false);
  };

  return (
    <div
      className={`${
        theme === "light" ? "banner-container-light" : "banner-container-dark"
      } banner-container`}
    >
      <Container>
        <Row className="text-center text-md-start">
          <Col
            data-aos="fade-right"
            xs={12}
            md={7}
            className="pt-4 order-2 order-md-1 "
          >
            <p className=" mb-2" style={{ color: "#999999" }}>
              WELCOME TO MY SPACE
            </p>
            <h1 style={{ fontSize: "45px", fontWeight: "bold" }}>
              👋Hey there,
              <br /> It’s <span style={{ color: "#f9004d" }}>SAIFUL ISLAM</span>
              <br />
              <span
                style={{
                  fontSize: "45px",
                  fontWeight: "500",
                  textTransform: "uppercase",
                }}
              >
                <Typewriter
                  typeSpeed={70}
                  deleteSpeed={50}
                  delaySpeed={1000}
                  loop
                  cursor
                  cursorStyle="|"
                  cursorBlinking={true}
                  words={["Software Developer", "Web Developer"]}
                />
              </span>
            </h1>
            <p className="mt-3" style={{ color: "#999999" }}>
              I am passionate about building excellent software that improves
              <br /> the lives of those around me.
            </p>
            <div className="mt-5">
              <p style={{ fontSize: "15px" }}>GET IN TOUCH</p>
              <a
                rel="noreferrer"
                href="https://github.com/siffahim"
                target="_blank"
                className="text-light"
              >
                <div
                  className={`${
                    theme === "light" ? "banner-icon-light" : "banner-icon-dark"
                  } banner-icon`}
                >
                  <i className="fa-brands fa-github"></i>
                </div>
              </a>
              <a
                rel="noreferrer"
                href="https://www.linkedin.com/in/siffahim/"
                target="_blank"
                className="text-light"
              >
                <div
                  className={`${
                    theme === "light" ? "banner-icon-light" : "banner-icon-dark"
                  } banner-icon`}
                >
                  <i className="fab fa-linkedin-in"></i>
                </div>
              </a>
              <a
                rel="noreferrer"
                href="mailto:siffahim25@gmil.com"
                target="_blank"
                className="text-light"
              >
                <div
                  className={`${
                    theme === "light" ? "banner-icon-light" : "banner-icon-dark"
                  } banner-icon`}
                >
                  <i className="fa-solid fa-envelope"></i>
                </div>
              </a>
            </div>
          </Col>
          <Col
            data-aos="fade-left"
            xs={12}
            md={5}
            className=" order-1 order-md-2"
          >
            <div className="img-container">
              <img src={profile} alt="" />

              <div className="btn-media" onClick={handleVideoOpen}>
                <i className="fa-solid fa-play"></i>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {show && (
        <div className="video-container">
          <video controls autoPlay loop src={vd}></video>
          <i
            onClick={handleVideoClose}
            className={`${
              theme === "light" ? "close-btn-dark" : "close-btn-light"
            } fa-solid fa-xmark close-btn`}
          ></i>
        </div>
      )}
    </div>
  );
};

export default Banner;
